export default class BroadcastState {
    public broadcastClass = "broadcastOff"
}


// WEBPACK FOOTER //
// ./src/components/stream/broadcast/BroadcastState.ts